import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-product-card]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-datalayer-product-card-links] a').forEach((cardDownload) => {
    cardDownload.addEventListener('click', datalayerProductCardLinks);
  });

  $$('[data-au-datalayer-product-button]').forEach((productButton) => {
    productButton.addEventListener('click', datalayerProductCardButton);
  });
}

function datalayerProductCardLinks(e) {
  const target = e.target;
  const isInsideLubesGuideResults = target.closest('[data-au-lubes-guide-results]');
  let titleText = target.closest('[data-au-product-card]').querySelector('[data-au-product-card-title]').innerText,
    clickText = target.querySelector(':not([data-au-icon])').innerText;
  const content_type = target.hasAttribute('download') ? 'clickDescarga' : 'clickEnlace';
  let item_id;

  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  // for lubes guide results, we need to get the title from the preview result card
  if (isInsideLubesGuideResults) {
    const model = isInsideLubesGuideResults.querySelector('[data-au-lubes-preview-result-card-title]').innerText;
    item_id = removeAccentMarkAndUppercase(`${model}_${titleText}_${clickText}`);
  } else {
    item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);
  }

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

function datalayerProductCardButton(e) {
  const target = e.target;
  let titleText = target.closest('[data-au-product-card]').querySelector('[data-au-product-card-title]').innerText,
    clickText = target.querySelector(':not([data-au-icon])').innerText,
    tagText = target.closest('[data-au-product-card]').querySelector('[data-au-product-card-tag]')?.innerText || '';
  const content_type = 'clickBoton';

  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;
  tagText = tagText.length > 100 ? `${tagText.substring(0, 100)}...` : tagText;

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${tagText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

export default { init };
